import { Dispatch } from 'redux';

import { TwilioClient } from 'ha/types/Twilio';

import { realtimeConnectionUpdated } from '../actions';
import { EventTypes } from '../constants';

export default (dispatch: Dispatch, client: TwilioClient) => () =>
  client.on(EventTypes.connectionStateChanged, connectionUpdate =>
    dispatch(realtimeConnectionUpdated(connectionUpdate)),
  );
